"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unregisterNativeCallback = exports.registryNativeCallback = exports.initNativeListener = exports.nativeAdaptor = void 0;

var utils_1 = require("./utils");

var isAndroid = (0, utils_1.isAndroidFn)();

function nativeAdaptor(_a) {
  var _b, _c, _d, _e;

  var actionName = _a.actionName,
      _f = _a.actionParams,
      actionParams = _f === void 0 ? {} : _f,
      callBackName = _a.callBackName,
      callback = _a.callback;
  console.log('actionName--', actionName, 'actionParams--', actionParams);
  var adaptor;

  if (isAndroid) {
    adaptor = (_b = window === null || window === void 0 ? void 0 : window.android) === null || _b === void 0 ? void 0 : _b[actionName];
  } else {
    adaptor = (_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.webkit) === null || _c === void 0 ? void 0 : _c.messageHandlers) === null || _d === void 0 ? void 0 : _d[actionName]) === null || _e === void 0 ? void 0 : _e.postMessage;
  }

  if (adaptor && typeof adaptor === 'function') {
    // 发送信息给原生
    var sendMsg = function sendMsg() {
      var _a, _b, _c, _d;

      if (isAndroid) {
        // 不使用 adaptor 引用来调用 bridge，否则安装下会报错：
        // Java bridge method can't be invoked on a non-injected object
        (_a = window === null || window === void 0 ? void 0 : window.android) === null || _a === void 0 ? void 0 : _a[actionName](JSON.stringify(actionParams));
      } else {
        (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.webkit) === null || _b === void 0 ? void 0 : _b.messageHandlers) === null || _c === void 0 ? void 0 : _c[actionName]) === null || _d === void 0 ? void 0 : _d.postMessage(JSON.stringify(actionParams));
      }
    };

    if (callBackName && callback) {
      // 1、注册回调
      var unregister = registryNativeCallback(callBackName, callback); // 2、组装要发送给原生的数据

      sendMsg(); // 3、移除注册回调方法，有的话

      return unregister;
    } else {
      sendMsg();
      return;
    }
  } else {
    console.error("\u65E0\u6CD5\u8C03\u8D77app\u65B9\u6CD5: ".concat(actionName));
    return;
  }
}

exports.nativeAdaptor = nativeAdaptor; // 回调句柄，用于保存所有回调方法的大对象

var ACTIONS_HANDLER = {};

function initNativeListener() {
  window.commentNativeToH5 = function (jsonData) {
    var data;
    console.log('接收到原生回调----------', jsonData);

    try {
      data = isAndroid ? jsonData : JSON.parse(decodeURIComponent(jsonData));
    } catch (_a) {
      data = {
        actionName: '',
        actionParams: ''
      };
    } // 历史原因：若数据转换失败，尝试 URL 解码后再转换
    // try {
    //   if (!data.actionName) {
    //     data = JSON.parse(decodeURIComponent(jsonData))
    //   }
    // } catch {
    //   data = {
    //     actionName: '',
    //     actionParams: ''
    //   }
    // }


    var callBackName = data.actionName,
        actionParams = data.actionParams;

    if (ACTIONS_HANDLER[callBackName]) {
      ACTIONS_HANDLER[callBackName].forEach(function (callback) {
        console.log('原生回调数据：', actionParams);
        callback(actionParams);
      });
    }
  };
}

exports.initNativeListener = initNativeListener; // 注册回调

function registryNativeCallback(callBackName, callback) {
  var handler = ACTIONS_HANDLER;

  if (!handler[callBackName]) {
    handler[callBackName] = [callback];
  } else {
    handler[callBackName].push(callback);
  }

  return function () {
    unregisterNativeCallback(callBackName, callback);
  };
}

exports.registryNativeCallback = registryNativeCallback; // 移除注册回调

function unregisterNativeCallback(callBackName, callback) {
  var callbackArray = ACTIONS_HANDLER[callBackName];

  if (Array.isArray(callbackArray) && callbackArray.length > 0) {
    // 移除相同引用队列元素
    ACTIONS_HANDLER[callBackName] = callbackArray.filter(function (c) {
      return c !== callback;
    });
  }
}

exports.unregisterNativeCallback = unregisterNativeCallback;